jPar.app = jPar.app || {};
jPar.app.appState = jPar.app.appState || {};
$j.extend(true, jPar.app.appState, {
	// Namespace removeNamespace()
	// Catergory setCategoryValue(), getCategoryValue(), removeCategory()
	// values addCategoryValue, removeCategoryValue
	// setMem / setDb

	set: function (storageName, namespaceKey, categoryKey, categoryVal) {
		if (browserDetails.features.hasStorageAccess()) {
			const storageType = this._getStorageType(storageName);
			const namespaceVal = storageType.getItem(namespaceKey);

			if (namespaceVal !== null && namespaceVal !== '') {
				const namespaceValAsJson = JSON.parse(namespaceVal);
				namespaceValAsJson[categoryKey] = categoryVal;
				storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
			} else {
				const newCategory = {};
				newCategory[categoryKey] = categoryVal;
				storageType.setItem(namespaceKey, JSON.stringify(newCategory));
			}
		}
	},

	// returns objects not plain String
	get: function (storageName, namespaceKey, categoryKey) {
		if (browserDetails.features.hasStorageAccess()) {
			const storageType = this._getStorageType(storageName);
			const namespaceVal = storageType.getItem(namespaceKey);

			const hasInvalidValue = namespaceVal === null || namespaceVal === '' || namespaceVal === '{}';
			if (hasInvalidValue) {
				return null;
			} else {
				const namespaceValAsJson = JSON.parse(namespaceVal);
				const hasInvalidCategory = namespaceValAsJson[categoryKey] === undefined;
				if (hasInvalidCategory) {
					return null;
				} else {
					return namespaceValAsJson[categoryKey];
				}
			}
		}
	},

	// TODO refactor get function. Add getNameSpace function
	getNameSpace: function (storageName, namespaceKey) {
		if (browserDetails.features.hasStorageAccess()) {
			const storageType = this._getStorageType(storageName);
			const namespaceVal = storageType.getItem(namespaceKey);

			const hasInvalidValue = namespaceVal === null || namespaceVal === '' || namespaceVal === '{}';
			if (hasInvalidValue) {
				return null;
			} else {
				return JSON.parse(namespaceVal);
			}
		}
	},

	addEntry: function (storageName, namespaceKey, categoryKey, categoryVal) {
		if (browserDetails.features.hasStorageAccess()) {
			const storageType = this._getStorageType(storageName);
			const namespaceVal = storageType.getItem(namespaceKey);

			if (namespaceVal !== null && namespaceVal !== '') {
				const namespaceValAsJson = JSON.parse(namespaceVal);
				const storedCategoryValue = namespaceValAsJson[categoryKey] !== undefined ? namespaceValAsJson[categoryKey] : '';

				const isInvalidNewVal = categoryVal.indexOf(',') > -1;
				if (isInvalidNewVal) {
					console.error('Adding Values with "," is not allowed');
					return;
				}

				const isValueNotInCategory = storedCategoryValue.includes(categoryVal) === false;
				if (isValueNotInCategory) {
					let newCategoryValue;
					if (storedCategoryValue.length === 0) {
						newCategoryValue = [categoryVal];
					} else {
						storedCategoryValue.push(categoryVal);
						newCategoryValue = storedCategoryValue;
					}

					namespaceValAsJson[categoryKey] = newCategoryValue;
					storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
				}
			} else {
				const newCategory = {};
				newCategory[categoryKey] = [categoryVal];
				storageType.setItem(namespaceKey, JSON.stringify(newCategory));
			}
		}
	},

	// Anzahl der Parameter entscheidet, auf welcher Ebene gelöscht wird
	remove: function (storageName, namespaceKey, categoryKey, categoryVal) {
		if (categoryVal !== undefined) {
			this._removeEntry(storageName, namespaceKey, categoryKey, categoryVal);
		} else if (categoryKey !== undefined && categoryVal === undefined) {
			this._removeCategory(storageName, namespaceKey, categoryKey);
		} else if (namespaceKey !== undefined) {
			this._removeNamespace(storageName, namespaceKey, categoryKey);
		}
	},

	_removeCategory: function (storageName, namespaceKey, categoryKey) {
		if (browserDetails.features.hasStorageAccess()) {
			const storageType = this._getStorageType(storageName);
			const namespaceVal = storageType.getItem(namespaceKey);

			if (namespaceVal !== null && namespaceVal !== '') {
				const namespaceValAsJson = JSON.parse(namespaceVal);
				delete namespaceValAsJson[categoryKey];
				storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
			}
		}
	},

	_removeEntry: function (storageName, namespaceKey, categoryKey, categoryVal) {
		if (browserDetails.features.hasStorageAccess()) {
			const storageType = this._getStorageType(storageName);
			const namespaceVal = storageType.getItem(namespaceKey);

			if (namespaceVal !== null && namespaceVal !== '') {
				const namespaceValAsJson = JSON.parse(namespaceVal);
				const storedCategoryValue = namespaceValAsJson[categoryKey];

				let storedCategoryValueAsArray = storedCategoryValue;
				if (typeof storedCategoryValue === 'string') {
					storedCategoryValueAsArray = storedCategoryValue.split(',');
				}

				if (storedCategoryValueAsArray.indexOf(categoryVal) > -1) {
					storedCategoryValueAsArray.splice(storedCategoryValueAsArray.indexOf(categoryVal), 1);
					namespaceValAsJson[categoryKey] = storedCategoryValueAsArray;
					storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
				}
			}
		}
	},

	_removeNamespace: function (storageName, namespaceKey) {
		if (browserDetails.features.hasStorageAccess()) {
			const storageType = this._getStorageType(storageName);
			storageType.removeItem(namespaceKey);
		}
	},

	// localStorage: Bleibt, bis man ihn löscht. Ist gleich über alle Tabs
	// sessionStorage: Immer nur für eine Session UND nur für einen Tab. Der Wert wird nicht synchron gehalten
	_getStorageType: function (storageName) {
		if (storageName === 'sessionStorage') {
			return sessionStorage;
		} else if (storageName === 'localStorage') {
			return localStorage;
		} else {
			console.error('Storage Type not Supported', storageName);
			return null;
		}
	},
});
